import moment from 'moment';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const MAX_DATE_RANGE_DAYS = 100;

export const emptyFilters = () => ({
  dateRange: { startDate: null, endDate: null },
  departmentIds: [],
  userIds: [],
});

export const dateRangeDays = ({ startDate, endDate }) => {
  if (!startDate || !endDate) return null;

  return moment(endDate, DATE_FORMAT).diff(moment(startDate, DATE_FORMAT), 'days') + 1;
};

export const dateRangeExceedsMax = (dateRange) => dateRangeDays(dateRange) > MAX_DATE_RANGE_DAYS;

// Day buckets and heatmap bands use the viewer's clock: the backend has no
// organization time zone.
export const userActivityParams = (filters) => ({
  start_date: filters.dateRange.startDate || undefined,
  end_date: filters.dateRange.endDate || undefined,
  department_ids: filters.departmentIds,
  user_ids: filters.userIds,
  utc_offset_minutes: -new Date().getTimezoneOffset(),
});

export const formatCount = (value) => (value || 0).toLocaleString();

export const percentOf = (value, total) => (total > 0 ? Math.round((value / total) * 100) : 0);

export const formatRangeLabel = ({ startDate, endDate }) => {
  if (!startDate || !endDate) return '';

  return `${moment(startDate, DATE_FORMAT).format('MMM D')} – ${moment(endDate, DATE_FORMAT).format('MMM D')}`;
};
